<template>
  <section class="app-main">
    <!-- <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <el-card
          v-if="
            key !== '/department/Department' &&
              key !== '/Department' &&
              key !== '/index'
          "
          class="box-card"
          style="min-height: 750px; margin-top: 40px;"
        >
          <router-view :key="key" />
        </el-card>
        <router-view v-else :key="key" />
      </keep-alive>
    </transition> -->
    <section class="app-main">
      <el-card
        v-if="key !== '/department/Department' && key !== '/Department'"
        class="box-card"
        style="min-height: 47rem; margin-top: 40px"
      >
        <transition name="fade-transform" mode="out-in">
          <keep-alive>
            <router-view v-if="$route.meta.noCache" :key="key" />
          </keep-alive>
        </transition>
        <router-view v-if="!$route.meta.noCache" :key="key" />
      </el-card>
      <router-view v-else :key="key" />
    </section>
  </section>
</template>

<script>
import { getUserHeadPhoto, setUserHeadPhoto } from "@/utils/auth";
import { isApprovePass } from "@/utils/date/date";
import {
  fetchGetLoginUserHeadPhoto //获取当前登录用户头像
} from "@/api/chat/AccountManagement";
export default {
  name: "AppMain",
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    }
  },
  mounted() {
    // 处理头像问题
    fetchGetLoginUserHeadPhoto().then(res => {
      const regex = /Expires=([0-9]+)/;
      const match = res.Data.match(regex);
      if (match) {
        const expires = match[1];
        this.$store.dispatch("users/HeadPhoto", { expires, photo: res.Data });
        // 存到本地
        setUserHeadPhoto({ expires, photo: res.Data });
      }
    });
  },
  updated() {
    // 处理头像问题
    if (
      !getUserHeadPhoto() ||
      (getUserHeadPhoto() && !isApprovePass(getUserHeadPhoto().expires, 1))
    ) {
      fetchGetLoginUserHeadPhoto().then(res => {
        const regex = /Expires=([0-9]+)/;
        const match = res.Data.match(regex);
        if (match) {
          const expires = match[1];
          // 存到本地
          setUserHeadPhoto({ expires, photo: res.Data });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 84px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}

.box-card {
  margin: 40px 20px 0;
  border: 1px solid #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// src/layout/components/AppMain.vue